import { FragmentDefiner, useReadFragment } from "../../../../GlobalHooks/useReadFragment";

import { Subsidiary } from "./model";
import { gql } from "@apollo/client/core";
import { useMutation } from "@apollo/client";

export const FRAGMENT_SUBSIDIARY_MASKED = new FragmentDefiner(
	"Subsidiary",
	`
    id
    name
    masked_phone
    address
    office_hours
`
);

const REQUEST_PHONE_MUTATION = gql`
	mutation request_phone_mutation($subsidiary_id: Int!, $property_id: Int!) {
		requestPhone(subsidiary_id: $subsidiary_id, property_id: $property_id)
	}
`;

interface useSubsidiaryResponse {
	subsidiary: Subsidiary;
	requestLoading: boolean;
	called: boolean;
	phone: string;
	viewPhone: CallableFunction;
}
export const useSubsidiary = ({ id }): useSubsidiaryResponse => {
	const { data } = useReadFragment(FRAGMENT_SUBSIDIARY_MASKED, id);

	const [mutation, { loading: requestLoading, data: mutation_response, called }] = useMutation(
		REQUEST_PHONE_MUTATION,
		{
			onError: () => {},
		}
	);

	const viewPhone = property_id => {
		return (
			mutation_response ??
			mutation({
				variables: {
					subsidiary_id: id,
					property_id,
				},
			})
		);
	};

	return {
		subsidiary: data,
		requestLoading,
		phone: mutation_response?.requestPhone,
		called,
		viewPhone,
	};
};
